import { X } from "lucide-react";
import { createPortal } from "react-dom";

import { useModalFocus } from "../lib/useModalFocus";

interface ResponsiveSheetProps {
  children: React.ReactNode;
  id: string;
  onClose: () => void;
  open: boolean;
  title: string;
}

export function ResponsiveSheet({ children, id, onClose, open, title }: ResponsiveSheetProps) {
  const sheetRef = useModalFocus<HTMLDivElement>({ focusKey: `${id}-${open}`, onEscape: onClose });
  if (!open || typeof document === "undefined") return null;

  return createPortal(
    <div className="responsive-sheet-backdrop" onMouseDown={(event) => {
      if (event.target === event.currentTarget) onClose();
    }}>
      <section
        aria-labelledby={`${id}-title`}
        aria-modal="true"
        className="responsive-sheet"
        id={id}
        ref={sheetRef}
        role="dialog"
        tabIndex={-1}
      >
        <header>
          <h2 id={`${id}-title`}>{title}</h2>
          <button aria-label={`Close ${title}`} className="responsive-sheet-close" onClick={onClose} type="button">
            <X aria-hidden="true" />
          </button>
        </header>
        <div className="responsive-sheet-content">{children}</div>
      </section>
    </div>,
    document.body,
  );
}
